// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2Le_b","rootSmall":"AddTileButton_rootSmall__3rsr0"};